import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';
import DeskNotes from './DeskNotes';
import AppErrorBoundary from './components/AppErrorBoundary';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      gcTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// /desk-notes is the desk-panel page the Zenoti Chrome extension iframes
// (extensions/desk-notes). It self-authorizes with a desk device token, so it
// must mount WITHOUT the authed app shell (no login, no LocationProvider, no
// notification gating). The ops app has no client router — views are state
// inside App — so a pathname check before the shell mounts is the seam
// (Vercel rewrites every path to index.html, so /desk-notes serves this
// bundle directly).
const isDeskNotes = window.location.pathname.replace(/\/+$/, '') === '/desk-notes';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      {isDeskNotes ? (
        <DeskNotes />
      ) : (
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      )}
    </AppErrorBoundary>
  </React.StrictMode>
);

// build-bust 2026-07-12: Vercel chained skipped builds to a stale cached output
// (ops.cutiepiewaxbar.com served a pre-envelope bundle); force a real rebuild.
// build-bust 2026-07-16: nav-item fix (4395903) didn't trigger a Vercel deploy
// (no deployment record); force a rebuild so the Divergence Review sidebar item ships.
